import moment from "moment";

/** The value of the period that is a range of dates the user typed in. */
export const CUSTOM_PERIOD = "custom";

/** The usual periods around today, as the planner offers them. */
export const PERIOD_PRESETS = [
  { value: "last_week", label: "Last week" },
  { value: "this_week", label: "This week" },
  { value: "next_week", label: "Next week" },
  { value: "last_month", label: "Last month" },
  { value: "this_month", label: "This month" },
  { value: "next_month", label: "Next month" },
];

const ISO_DATE = "YYYY-MM-DD";

const span = (start, end) => ({ startDate: start.format(ISO_DATE), endDate: end.format(ISO_DATE) });

/**
 * The first and last day, written yyyy-MM-dd, of one of the usual periods around a day (today by default). Weeks run
 * Monday to Sunday, months are calendar months, and anything that is not a known period is this week.
 */
export function presetRange(preset, today = moment()) {
  const weekStart = moment(today).startOf("isoWeek");
  const monthStart = moment(today).startOf("month");

  switch (preset) {
    case "last_week":
      return span(weekStart.clone().subtract(7, "days"), weekStart.clone().subtract(1, "days"));
    case "next_week":
      return span(weekStart.clone().add(7, "days"), weekStart.clone().add(13, "days"));
    case "last_month": {
      const start = monthStart.clone().subtract(1, "month");
      return span(start, start.clone().endOf("month"));
    }
    case "this_month":
      return span(monthStart, monthStart.clone().endOf("month"));
    case "next_month": {
      const start = monthStart.clone().add(1, "month");
      return span(start, start.clone().endOf("month"));
    }
    case "this_week":
    default:
      return span(weekStart, weekStart.clone().add(6, "days"));
  }
}
